import React from "react";
import EstralabsLanding from "../assets/Estralabs_Landing.png"; 



const ImagenComponent = () => {
    return (
        <section className="Imagen">
            <div className="image">
                <img src={EstralabsLanding} alt="img" />
            </div>
        </section>
    );
};

export default ImagenComponent;

